import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-employee-report-dialog',
  templateUrl: './employee-report-dialog.component.html',
  styleUrls: ['./employee-report-dialog.component.scss']
})

export class EmployeeReportDialogComponent {

  data = this.config.data
  
  constructor(public config: DynamicDialogConfig) { }

}
